import { PassPurchaseForm } from 'booking/components';
import { BasicPassFragment, Maybe, useGetPassQuery } from 'drycut-graphql';
import { useNavigate, useParams } from 'react-router';
import { Loader } from 'ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function NewPassPurchase(): React.ReactNode {
  useDocumentTitle('DRYCUT - DRYPASS');

  const { slug, passId } = useParams() as { slug: string; passId: string };
  const { data, loading } = useGetPassQuery({ variables: { passId } });
  const navigate = useNavigate();

  const pass: Maybe<BasicPassFragment> = data?.pass || null;

  if (loading) {
    return <Loader />;
  }

  if (!pass) {
    navigate('/not-found');
    return null;
  }

  return <PassPurchaseForm storeSlug={slug} pass={pass} manual />;
}
